// extracted by mini-css-extract-plugin
export default {"snacks":"SnackbarContext_snacks__mDyTD"};